export const imgSuccess = require('../../packages/bulk-ping-ui/imgs/success.svg');
export const imgWheel = require('../../packages/bulk-ping-ui/imgs/wheel.svg');
export const imgExclamation = require('../../packages/bulk-ping-ui/imgs/exclamation.svg');
export const imgCross = require('../../packages/bulk-ping-ui/imgs/cross.svg');
export const imgVfLogo = require('../../packages/bulk-ping-ui/imgs/vf-logo.png');
export const imgCancelled = require('../../packages/bulk-ping-ui/imgs/cancelled.svg');
export const imgLogout  = require('../../packages/bulk-ping-ui/imgs/logout.svg')
export const imgBmpLogo  = require('../../packages/bulk-ping-ui/imgs/bmp-logo.svg')


